import SpeechRecognition, { useSpeechRecognition } from './SpeechRecognition'

export { useSpeechRecognition }
export default SpeechRecognition
